export type ActionType =
  | 'SET_CANCELLATION_VOUCHER_DATA'
  | 'REQUEST_CANCELLATION_VOUCHER_DATA'
  | 'RECEIVED_CANCELLATION_VOUCHER_DATA'
  | 'ERROR_CANCELLATION_VOUCHER_DATA';

interface ActionProps {
  type: ActionType;
  isFetching?: boolean;
  data?: {} | any;
  error?: any;
  payload?: {} | any;
}

const initialCancellationVoucherState = {
  isFetching: true,
  data: {},
  error: {},
};

const CancellationVoucher = (
  state = initialCancellationVoucherState,
  action: Partial<ActionProps>,
) => {
  switch (action.type) {
    case 'REQUEST_CANCELLATION_VOUCHER_DATA': {
      return {
        ...state,
      };
    }

    case 'RECEIVED_CANCELLATION_VOUCHER_DATA': {
      const { payload = {} } = action;
      return {
        ...state,
        isFetching: false,
        data: { ...payload },
      };
    }

    case 'ERROR_CANCELLATION_VOUCHER_DATA': {
      const { error = {} } = action;
      return {
        ...state,
        isFetching: false,
        error: { ...error },
      };
    }

    default:
      return state;
  }
};

export default CancellationVoucher;
